// extracted by mini-css-extract-plugin
export default {"isWaiting":"TwoFaContainer_isWaiting__VhN3x","button":"TwoFaContainer_button__De64R"};